import React from 'react';
import { Palette, Type, Zap, ZapOff, Check } from 'lucide-react';
import { ModuleHeader } from '../../../../components/shared/ModuleHeader/ModuleHeader';
import './AdministrationView.css';

const THEME_COLORS = [
  { name: 'AVAP Green', value: '#00ab84' },
  { name: 'Classic Blue', value: '#0018a8' },
  { name: 'Alert Red', value: '#ef4444' },
  { name: 'Warning Orange', value: '#f97316' },
  { name: 'Royal Purple', value: '#a855f7' },
  { name: 'Cyber Yellow', value: '#eab308' },
  { name: 'Slate Gray', value: '#64748b' },
];

const FONT_OPTIONS = [
  { name: 'JetBrains Mono', value: 'JetBrains Mono' },
  { name: 'Inter', value: 'Inter' },
  { name: 'Space Grotesk', value: 'Space Grotesk' },
  { name: 'Fira Code', value: 'Fira Code' },
];

export interface AdministrationViewProps {
  primaryColor: string;
  setPrimaryColor: (value: string) => void;
  fontFamily: string;
  setFontFamily: (value: string) => void;
  animationsEnabled: boolean;
  setAnimationsEnabled: (value: boolean) => void;
}

export const AdministrationView: React.FC<AdministrationViewProps> = ({
  primaryColor,
  setPrimaryColor,
  fontFamily,
  setFontFamily,
  animationsEnabled,
  setAnimationsEnabled
}) => {
  return (
    <div className="administration-container">
      <ModuleHeader
        title="Administración_Sistema"
        subtitle="Ajustes de preferencias globales, aspecto e identidad visual de la plataforma."
      />

      <div className="admin-grid">
        {/* Card 1: Color Primario Interfaz */}
        <div className="admin-card">
          <div>
            <div className="admin-card-header">
              <Palette className="admin-card-icon" size={18} />
              <h3 className="admin-card-title">Color_Primario_Interfaz</h3>
            </div>
            <p className="admin-card-desc">
              Selecciona el tono de énfasis para los botones, bordes, estados activos y elementos visuales clave de todo el sistema.
            </p>
            <div className="admin-color-grid">
              {THEME_COLORS.map((color) => (
                <button
                  key={color.value}
                  onClick={() => setPrimaryColor(color.value)}
                  className={`admin-color-btn ${primaryColor === color.value ? 'active' : ''}`}
                  title={color.name}
                >
                  <div className="admin-color-swatch" style={{ backgroundColor: color.value }} />
                  <span className="admin-color-name">{color.name.split(' ')[0]}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Card 2: Tipografía de la Plataforma */}
        <div className="admin-card">
          <div>
            <div className="admin-card-header">
              <Type className="admin-card-icon" size={18} />
              <h3 className="admin-card-title">Tipografía_Sistema</h3>
            </div>
            <p className="admin-card-desc">
              Cambia la familia tipográfica principal utilizada en todos los menús, etiquetas, reportes de datos y consolas.
            </p>
            <div className="admin-font-grid">
              {FONT_OPTIONS.map((font) => (
                <button
                  key={font.value}
                  onClick={() => setFontFamily(font.value)}
                  className={`admin-font-btn ${fontFamily === font.value ? 'active' : ''}`}
                  style={{ fontFamily: font.value }}
                >
                  <span className="admin-font-name">{font.name}</span>
                  {fontFamily === font.value && <Check size={12} />}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Card 3: Efectos Visuales y Animaciones */}
        <div className="admin-card admin-card-full">
          <div>
            <div className="admin-card-header">
              {animationsEnabled ? <Zap className="admin-card-icon active-bounce" size={18} /> : <ZapOff className="admin-card-icon-inactive" size={18} />}
              <h3 className="admin-card-title">Animaciones_FX_Entorno</h3>
            </div>
            <div className="admin-anim-content">
              <div className="admin-anim-text">
                <p className="admin-card-desc">
                  Habilita o deshabilita las transiciones fluidas de páginas, efectos de escalado en botones y micro-animaciones del sistema para una experiencia más rápida o eficiente en hardware limitado.
                </p>
              </div>
              <button
                onClick={() => setAnimationsEnabled(!animationsEnabled)}
                className={`admin-anim-btn ${animationsEnabled ? 'active' : ''}`}
              >
                {animationsEnabled ? 'ANIMACIONES: ACTIVAS' : 'ANIMACIONES: DESACTIVADAS'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
